import React from 'react';
import './styles/customRadioBtn.css';   // make sure this import comes *after* your Tailwind imports

const RadioButton = ({ label, value, checked, defaultChecked, onChange }) => {
  return (
    <label className="radio-container whitespace-nowrap">
      <input
        type="radio"
        name="radio"
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={() => onChange(value)}
      />
      <span className="radio-checkmark"></span>
      {label}
    </label>
  );
};

export default RadioButton;
